export default __webpack_public_path__ + "static/media/13.blur.96a81329.jpeg";